import { call, put, takeLatest } from 'redux-saga/effects';

import * as Apis from '../api/Auth.api';
import {
	RemoveUserAction,
	REMOVE_USER,
	REMOVE_USER_ERROR,
	REMOVE_USER_SUCCESS,
	SignInUserAction,
	SignUpUserAction,
	SIGN_IN_USER,
	SIGN_IN_USER_ERROR,
	SIGN_IN_USER_SUCCESS,
	SIGN_UP_USER,
	SIGN_UP_USER_ERROR,
	SIGN_UP_USER_SUCCESS,
} from '../constants/ActionTypes';

function* signUpUser({ payload, success, failed }: SignUpUserAction) {
	try {
		const data = yield call(Apis.signUpUserApi, payload);
		success?.(data);
		yield put({
			type: SIGN_UP_USER_SUCCESS,
			payload: { data, authType: payload.authType },
		});
	} catch (err) {
		failed?.(err);
		yield put({ type: SIGN_UP_USER_ERROR, err });
	}
}

function* signInUser({ payload, success, failed }: SignInUserAction) {
	try {
		const data = yield call(Apis.signInUserApi, payload);
		success?.(data);
		yield put({
			type: SIGN_IN_USER_SUCCESS,
			payload: { data, authType: payload.authType },
		});
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: SIGN_IN_USER_ERROR, err });
	}
}

function* deleteUser({ payload, success, failed }: RemoveUserAction) {
	try {
		const data = yield call(Apis.deleteUserApi, payload);
		success?.(data);
		yield put({
			type: REMOVE_USER_SUCCESS,
			payload: data,
		});
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: REMOVE_USER_ERROR, err });
	}
}

function* AuthSaga() {
	yield takeLatest(SIGN_UP_USER, signUpUser);
	yield takeLatest(SIGN_IN_USER, signInUser);
	yield takeLatest(REMOVE_USER, deleteUser);
}

export default AuthSaga;
